import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { ModuleRegistry, ClientSideRowModelModule, InfiniteRowModelModule } from 'ag-grid-community';

ModuleRegistry.registerModules([ClientSideRowModelModule, InfiniteRowModelModule]);

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
//